import { Link } from 'react-router-dom';
import { animeCategories, mangaCategories } from '@/mocks/categories';
import SectionHeading from '@/components/feature/SectionHeading';

function CategoryGrid({
  items,
  basePath,
}: {
  items: { id: string; name: string; tag: string; desc: string; image: string }[];
  basePath: string;
}) {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
      {items.map((cat) => (
        <Link
          key={cat.id}
          to={`${basePath}/${cat.id}`}
          className="group relative overflow-hidden rounded-lg border border-background-200/70"
        >
          <div className="relative aspect-[3/2] overflow-hidden bg-background-100">
            <img
              src={cat.image}
              alt={`${cat.name}分类`}
              title={`动漫网 ${cat.name} 分类`}
              className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/10 to-transparent"></div>
            <span className="absolute left-2 top-2 rounded bg-background-50/90 px-2 py-0.5 text-[11px] font-semibold text-primary-700">
              {cat.tag}
            </span>
            <div className="absolute inset-x-0 bottom-0 p-3">
              <h3 className="font-heading text-lg text-background-50">{cat.name}</h3>
              <p className="mt-0.5 truncate text-xs text-background-50/75">{cat.desc}</p>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}

export default function CategoryShowcase() {
  return (
    <section className="bg-background-100/60 py-12 md:py-16" aria-label="分类入口">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          title="动画分类"
          desc="按题材快速筛选，从热血到治愈，总有一款适合你"
        />
        <CategoryGrid items={animeCategories} basePath="/category" />
      </div>

      <div className="mx-auto mt-10 max-w-7xl px-4 md:px-6">
        <SectionHeading
          title="漫画分类大全"
          desc="少年漫、少女漫、青年漫……带你畅游漫画世界"
        />
        <CategoryGrid items={mangaCategories} basePath="/category" />
      </div>
    </section>
  );
}